module.exports = "<app-dash></app-dash>\r\n"